import Common from './modules/common/Common.svelte';
import RestockablePopupContentSvelteComponent from './modules/common/components/restockable/RestockablePopupContent.svelte';
import RecentlyViewedSvelteComponent from './modules/home/component/RecentlyViewed.svelte';
import RecommendationsSvelteComponent from './modules/home/component/Recommendation/RecommendationsMain.svelte';
import RichRelavanceSvelteComponent from './modules/home/component/RichRelavance.svelte';
import AddToCartDialogSvelteComponent from './modules/product-details/components/AddToCartDialog.svelte';

// Attaching all components to the global window object
if (window['RecommendationsSvelteComponent'] === undefined) {
  window['RecommendationsSvelteComponent'] = RecommendationsSvelteComponent;
}
if (window['RecentlyViewedSvelteComponent'] === undefined) {
  window['RecentlyViewedSvelteComponent'] = RecentlyViewedSvelteComponent;
}
if (window['RichRelavanceSvelteComponent'] === undefined) {
  window['RichRelavanceSvelteComponent'] = RichRelavanceSvelteComponent;
}
if (window['RestockablePopupContentSvelteComponent'] === undefined) {
  window['RestockablePopupContentSvelteComponent'] = RestockablePopupContentSvelteComponent;
}

if (window['AddToCartDialogSvelteComponent'] === undefined) {
  window['AddToCartDialogSvelteComponent'] = AddToCartDialogSvelteComponent;
}

console.log('[shared-loader] Shared components attached to window.');

// Function to safely mount a component to a DOM element if present
function safelyMountComponent(ComponentClass: typeof Common, targetId: string) {
  const target = document.getElementById(targetId);
  if (target) {
    new ComponentClass({ target });
    console.log(` Mounted ${ComponentClass.name} on #${targetId}`);
  } else {
    console.warn(`Skipped mounting ${ComponentClass.name}. Element #${targetId} not found.`);
  }
}

// Wait for DOM to be ready before mounting any DOM-bound components
document.addEventListener('DOMContentLoaded', () => {
  safelyMountComponent(Common, 'common');
});
